import { useContext } from 'react';
import { useLocation, Routes, Route, Navigate, Link } from 'react-router-dom';

import { UserContext } from '../UserProvider';

import SubNavbar from '../SubNavbar';
import CourseHome from './CourseHome'

const Courses = ({pathPrefix}) => {
  const { appList } = useContext(UserContext);
  const courseApp = appList.find(e => e.label === 'Courses');

  // get the local (in module) part of the path
  const location = useLocation();
  const localPath = location.pathname.substring(pathPrefix.length);

  // no courses bailout
  if (!courseApp || !courseApp.appData || courseApp.appData.length === 0) {
    return (<></>);
  }

  /////////////////////////
  // render
  /////////////////////////

  // fn/manage/rosters/CSCI.1170.01

  // ptl/courses/sectionId/assn
  
  // two-level app navigation
  const navSections = courseApp.appData.map(({id, term_code, crn, subject, number, section, keys}) => 
    ({label: number, path: `${id}`,
      sections: [
        {label: 'Assignments', path: 'assns'},
        {label: 'In-Class', path: 'in-class'},
        {label: 'Midterm', path: 'midterm'},
        {label: 'Final', path: 'final'},
        {label: 'Totals', path: 'totals_display'}
        ].filter(subSection => keys.includes(subSection.path))
      }));

  return (
    <>
      <SubNavbar navSections={navSections} localPath={localPath} />
      <Routes>
        {navSections.length === 1
        ?
        <Route path='/' element={<Navigate to={navSections[0].path} />} />
        :
        <Route path='/' element={<></>} />}
        <Route path='/:sectionId/*' element={<CourseHome />} />
      </Routes>
    </>
  );
};

export default Courses;
